export const ESSENTIALS_FOR_ALL_ACCOUNTS = false;
export const ESSENTIALS_PILOT_SOURCE = "DSC.AI";

export const SUBSCRIPTION_INCLUDES = [
  "200+ ready-to-play content feeds",
  "Unlimited user accounts",
  "Easy screen registration and setup",
  "Social Media + Workplace apps",
  "Role-based permissions",
  "Single Sign-On (SSO)",
  "Content upload with auto-design",
  "Manual and auto-curation",
  "Free onboarding and training",
  "Custom branding (logo, colors & font)",
  "Smart scheduling (dayparting)",
  "Chat, ticket, and email support",
];

export enum PlanNameEnum {
  "all_in" = "best-value-plan",
  "essentials" = "essentials",
  "infotainment" = "infotainment",
  "teams" = "teams",
  "social" = "social",
  "social_teams" = "social-teams",
  "infotainment_teams" = "infotainment-teams",
  "infotainment_social" = "infotainment-social",
}
